module.exports = __webpack_public_path__ + "static/media/insta_logo.d473f61a.png";